export const STORE_LAST_MONTH_USER_VISITS = 'lastMonthUserVisits';
export const IS_APP_DOWNLOADED = 'isAppDownloaded';
export const STORE_IS_REGISTRED = 'isRegistred';
export const FACEBOOK_LINK = 'https://www.facebook.com/discoverfotoscapes/';
export const VISITS_DURING_DECLINE_SUBSCRIPTION =
  'visitsDuringDeclineSubscription';

export enum eventTypes {
  CONTENT_CLICK = 'content_click',
  INTEREST_CLICK = 'interest_click',
  LINK_CLICK = 'link_click',
  SWIPE = 'swipe',
  PAGE_VIEW = 'pageview',
  TAP = 'tap',
  SCROLL = 'scroll',
  AD_IMPRESSION = 'ad_impression',
  FIRST_VISIT = 'first_visit',
  AD_NOT_RENDERED = 'ad_not_rendered',
  AD_RENDERED = 'ad_rendered',
  CONTENT_DISMISSED = 'content_dismissed',
  STORY_DISMISSED = 'story_dismissed',
  CONTENT_IMPRESSION = 'content_impression',
  PAGE_LOADED = 'page_loaded',
  PAGE_NOT_LOADED = 'page_not_loaded',
  WIDGET_IMPRESSION = 'widget_impression',
  WIDGET_CLICK = 'widget_click',
  ERROR = 'error',
  IMPRESSION = 'impression',
  VIEWABLE_IMPRESSION = 'viewable_impression',
  AD_SLOT_RENDERED = 'ad_slot_rendered',
  AD_PREBID_AUCTION_END = 'ad_prebid_auction_end',
  AD_PREBID_BID_WON = 'ad_prebid_bid_won',
  AD_PREBID_RENDER_SUCCEEDED = 'ad_prebid_render_succeeded',
  AD_PREBID_RENDER_FAILED = 'ad_prebid_render_failed',
  AD_SLOT_LOADED = 'ad_slot_loaded',
  AD_SLOT_RESPONSE_RECEIVED = 'ad_slot_response_received',
  AD_SLOT_DUPLICATE_REFRESH = 'ad_slot_duplicate_refresh',
}
